import { createFileRoute } from '@tanstack/react-router';

import { ReviewHourlyTuitionPage } from '~pages/payments/hourly-tuitions/review';

export const Route = createFileRoute(
  '/_auth/_layout/payment/hourly-tuition/review',
)({
  component: ReviewHourlyTuitionPage,
});
